import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import InfoPageBody from './InfoPageBody';
import { INFO_PAGE_CONTENT } from './infoPageContent';
import './FooterInfoPanel.css';

const FooterInfoPanel = ({ pageKey, onClose }) => {
  const panelBodyRef = useRef(null);
  const page = pageKey ? INFO_PAGE_CONTENT[pageKey] : null;

  useEffect(() => {
    if (!pageKey) return undefined;

    const scrollY = window.scrollY;
    const prevOverflow = document.body.style.overflow;
    const prevPosition = document.body.style.position;
    const prevTop = document.body.style.top;
    const prevWidth = document.body.style.width;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.position = prevPosition;
      document.body.style.top = prevTop;
      document.body.style.width = prevWidth;
      window.scrollTo(0, scrollY);
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [pageKey, onClose]);

  useEffect(() => {
    if (panelBodyRef.current) {
      panelBodyRef.current.scrollTop = 0;
    }
  }, [pageKey]);

  if (!pageKey || !page) return null;

  return createPortal(
    <div className="footer-info-panel-root" role="presentation">
      <button
        type="button"
        className="footer-info-panel-backdrop"
        onClick={onClose}
        aria-label="Close"
      />
      <div
        className="footer-info-panel-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="footer-info-panel-title"
      >
        <div className="footer-info-panel-toolbar">
          <button
            type="button"
            className="footer-info-panel-back"
            onClick={onClose}
            aria-label="Go back"
          >
            <span className="footer-info-panel-back-icon" aria-hidden="true">‹</span>
            <span>Back</span>
          </button>
          <h2 id="footer-info-panel-title">{page.title}</h2>
          <button
            type="button"
            className="footer-info-panel-close"
            onClick={onClose}
            aria-label="Close"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" aria-hidden="true">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div>
        <div className="footer-info-panel-body" ref={panelBodyRef}>
          <InfoPageBody page={page} variant="panel" />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FooterInfoPanel;
